require('./helpers/bundle-manifest').register(JSON.parse("{\"jAM09\":\"main.js\",\"h9GFp\":\"menu-usa.432c4692.js\",\"jUTBd\":\"menu-usa.css\"}"));